import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Fade } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import { useMatomo } from "@datapunt/matomo-tracker-react";
import { reserveQuota } from "../../clientAPI";
import { useUserState } from "../../context/UserContext";
import { useHistory } from "react-router-dom";
import { handlePlayMovie, handlePlayTrailer } from "../../context/VideoContext";
import LoginAlertDialog from "../../components/LoginAlertDialog";
import VideoQuotaExceedDialog from "../../components/VideoQuotaExceedDialog";

const errorImage = require("../../images/error/image_not_found.png");
const useStyles = makeStyles(theme =>
  createStyles({
    videoSideBar: {
      maxWidth: 280,
      maxHeight: 500,
      paddingTop: theme.spacing(9),
      padding: theme.spacing(2),
      overflowY: "auto",
    },
    videoItem: {
      display: "flex",
      marginBottom: theme.spacing(2),
      cursor: "pointer",
      // transition: "background-color 0.3s, box-shadow 0.3s",
      // "&:hover, &:focus": {
      //   zIndex: 100,
      //   backgroundColor: "#f0f0f0",
      //   boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      // },
      // borderRadius: theme.spacing(1),
    },
    thumbnail: {
      width: 160,
      height: 90,
      objectFit: "cover",
      [theme.breakpoints.between("sm", "md")]: {
        width: 120,
        height: 60,
      },
    },
    videoInfo: {
      marginLeft: theme.spacing(1),
    },
    videoTitle: {
      ...theme.typography.subtitle2,
      color: "white",
      margin: 0,
    },
  }),
);

const VideoSideBarItem = ({
  item,
  playerRef,
  setOpenLoginDialog,
  setOpenQuotaDialog,
  onSelect,
}) => {
  const classes = useStyles();

  const { isAuthenticated } = useUserState();

  const isLogin = isAuthenticated;
  const isTrailer = item.videoType === "trailer";
  const isTrailerUrl = window.location.pathname.indexOf("trailer") !== -1;
  const videoId = item.videoId;
  const { trackEvent } = useMatomo();
  const history = useHistory();

  const handleClickPlayMovie = () => {
    handlePlayMovie({
      isLogin,
      isTrailer: isTrailerUrl,
      videoId,
      history,
      reserveQuota,
      setOpenLoginDialog,
      setOpenQuotaDialog,
      player: playerRef.current,
      trackEvent,
    });
  };

  const handleClickPlayTrailer = () => {
    handlePlayTrailer({
      isLogin,
      isTrailer: isTrailerUrl,
      videoId,
      history,
      reserveQuota,
      setOpenLoginDialog,
      setOpenQuotaDialog,
      player: playerRef.current,
      trackEvent,
    });
  };

  return (
    <div
      className={classes.videoItem}
      onClick={() => {
        if (isTrailer) {
          handleClickPlayTrailer();
        } else {
          handleClickPlayMovie();
        }
        onSelect(item.id);
      }}
    >
      <img
        className={classes.thumbnail}
        src={item.thumbnail}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = errorImage;
        }}
        alt={item.title}
      />

      <div className={classes.videoInfo}>
        <p className={classes.videoTitle}>
          {item.title}
          {/* <br />
          {item.langName} */}
        </p>
      </div>
    </div>
  );
};

const VideoSideBar = ({ playerRef, items }) => {
  const classes = useStyles();

  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [openQuotaDialog, setOpenQuotaDialog] = useState(false);

  const handleSelect = (id) => {
    setSelectedVideoId(id);
  };

  return (
    <div className={classes.videoSideBar}>
      {items.map(item => (
        <VideoSideBarItem
          key={item.id}
          item={item}
          playerRef={playerRef}
          setOpenLoginDialog={setOpenLoginDialog}
          setOpenQuotaDialog={setOpenQuotaDialog}
          onSelect={handleSelect}
        />
      ))}
      <LoginAlertDialog open={openLoginDialog} setOpen={setOpenLoginDialog} />
      <VideoQuotaExceedDialog
        open={openQuotaDialog}
        setOpen={setOpenQuotaDialog}
      />
    </div>
  );
};

export default VideoSideBar;
